import { Button, CircularProgress, Grid, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import useSdk from "../../hooks/useSdk";
import { useStore } from "../../hooks/useStore";
import useTabs from "../../hooks/useTabs";
import { useTranslation } from "../../hooks/useTranslation";
import { dataReset } from "../../redux/actions/dataAction";
import { tabSetUsersByIndex } from "../../redux/actions/tabActions";
import UserPreview from "./UserPreview/UserPreview";
import {UserState} from "../../passapp-sdk/types/userTypes";

type MultipleExitProps = {
  index: number;
  initialUsers?: UserState[];
};

const MultipleExit = ({ index, initialUsers }: MultipleExitProps) => {
  const { t, BundleKey } = useTranslation();
  const { dataStore } = useStore();
  const { user } = useSdk(undefined, dataStore.config, dataStore.user);
  const dispatch = useDispatch();
  const [users, setUsers] = useState<UserState[]>(initialUsers || []);
  const { onCloseTab } = useTabs();

  useEffect(() => {
    if (user && users.length === 0) {
      let array: UserState[] = [];
      user.companions?.forEach((companion) => {
        array.push(companion);
      });
      let auxUser: any = user;
      delete auxUser.companions;
      array.push(auxUser);
      setUsers(array);
      dispatch(tabSetUsersByIndex(index, array));
      setTimeout(() => {
        dispatch(dataReset());
      }, 1000);
    }
  }, [user]);

  const finalize = () => {
    onCloseTab(index);
  };

  const editUser = (userModify: UserState) => {
    let edit = users.map((user) => {
      if (user.id === userModify.id) user = { ...userModify };
      return user;
    });
    setUsers(edit);
    dispatch(tabSetUsersByIndex(index, edit));
  };

  return (
    <>
      {initialUsers && initialUsers?.length !== 0 ? (
        <div style={{ padding: 20 }}>
          <Grid container direction="column" spacing={4}>
            <Grid item>
              <Typography variant="h5" style={{ margin: 10 }}>
                {t(BundleKey.DIALOG_MULTIPLEEXIT_TITLE)}
              </Typography>
            </Grid>
            {initialUsers?.map((user, index) => (
              <Grid item xs={12} key={index}>
                <UserPreview
                  user={user}
                  onEditUser={editUser}
                  driver={user.isDriver}
                />
              </Grid>
            ))}
            <Grid item xs={12}>
              <Grid container justifyContent="center">
                <Grid item xs={12} sm={4}>
                  <Button
                    variant="contained"
                    size="large"
                    color="primary"
                    fullWidth
                    onClick={finalize}
                  >
                    {t(BundleKey.ACTION_FINALIZE)}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      ) : (
        <div
          style={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress />
        </div>
      )}
    </>
  );
};

export default MultipleExit;
